<template>
    <card>
        <Button type="primary" @click="black()">
            <Icon type="chevron-left"></Icon>
            返回
        </Button>
        <div class="k">
            <div class="news-list">
                <div style="font-size: 24px">可能疾病</div><br>
                <div style="font-size: 28px;"><strong>{{this.$route.query.name}}</strong></div><br><br>
                <div style="font-size: 24px">推荐科室</div><br>
                <div v-for="(item, index) in dataList" :key="index">
                    <div class="news-content">
                        {{ item.class }}
                    </div><br>
                </div>
            </div>
        </div>
    </card>
</template>

<script>
    export default {
        data() {
            return {
                dataList: [],
            };
        },
        created() {
            this.getBodyPartsList();
        },methods: {
            getBodyPartsList() {
                this.abHttpUtil
                    .post("/form/formCustSql/view/list_BodySymptomsInterface", {
                        curPage: 1,
                        pageSize: 100,
                        params: { queryData: [{ name: "body_parts_class.body_parts_symptoms_id", con: "=", val: this.$route.query.id_ }] }
                    })
                    .then(
                        (result) => {
                            this.dataList = result.data.list;
                        },
                        function (status) {
                            if (status == !0) {
                                this.$Message.error("加载失败！" + status);
                            }
                        }
                    );
            },
            black() {
                this.$router.push({
                    path: "/LeadingExamining",
                });
            },
        },
    }
</script>

<style scoped>

    .news-content {
        font-size: 28px;
        background-color: #9bc4ff;
        color: #0a80ff;
        width: 30%;
        margin-left: 35%;
        border: 3px solid;
        border-color: #0a80ff;
    }

    .k {
        text-align:center;
    }
</style>
